/** Required / Recommended marker next to a field label (`FieldDef.priority`,
 *  `PROPOSAL_HELP.priority`).
 *
 *  Required is the default expectation of a form field, so it's a quiet red
 *  asterisk (a filled chip created badge fatigue — DESIGN.md §3.3); Recommended
 *  is the unusual, useful signal (it drives report quality), so it keeps an
 *  amber chip. */

interface Props {
  priority: 'required' | 'recommended' | undefined
}

export function PriorityBadge({ priority }: Props) {
  if (!priority) return null
  if (priority === 'required') {
    return (
      <span
        data-testid="priority-required"
        title="Required for AWS Fund Request submission"
        aria-label="required"
        style={{
          marginLeft: '0.3rem',
          color: 'var(--accent)',
          fontWeight: 700,
          lineHeight: 1,
        }}
      >
        *
      </span>
    )
  }
  return (
    <span
      data-testid="priority-recommended"
      className="chip chip--warn"
      title="Recommended for a high-quality assessment"
      style={{ marginLeft: '0.4rem', fontSize: '0.6rem', textTransform: 'uppercase', letterSpacing: '0.04em' }}
    >
      Recommended
    </span>
  )
}
